import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import {
  type IActionItemsStatusesStats,
  type IActionItemsStatusesStatsKeys,
} from '../model/actionItemsStatuses';

const aiStatusesKey = (locationIds: Array<number>) => ['aiStatuses', locationIds];

const aiStatusesFn = ({ queryKey }: QueryFunctionContext<string[]>) => {
  return apiClient.get<{ data: IActionItemsStatusesStats }>(
    `${APP_API_URL_V2}fsd/action-item/executive-summary/action-items-statuses`,
    {
      params: {
        location_ids: queryKey[1],
      },
    },
  );
};

const aiStatusesSelect = ({ data }: AxiosResponse<{ data: IActionItemsStatusesStats }>) => data.data;

export const useAiStatusesQuery = ({ locationIds }: IActionItemsStatusesStatsKeys) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: aiStatusesKey(locationIds),
    queryFn: aiStatusesFn,
    placeholderData: {
      data: {
        data: {},
      },
    },
    select: aiStatusesSelect,
  });
};
